import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./reducers/authSlice";
import { messengerReducer } from "./reducers/messengerSlice";
import templateReducer from "./reducers/templateSlice";
import templateMessageSendReducer from "./reducers/templateMessageSendSlice";
import mediaMessageReducer from "./reducers/mediaMessageSlice";
import newTemplateListReducer from "./reducers/newTemplateListSlice";
import newTemplateMessageSendReducer from "./reducers/newTemplateMessageSendSlice";
import notificationReducer from "./reducers/notificationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    messenger: messengerReducer,
    template: templateReducer,
    templateMessage: templateMessageSendReducer,
    mediaMessage: mediaMessageReducer,
    newTemplateList: newTemplateListReducer,
    newTemplateMessage: newTemplateMessageSendReducer,
    notifications: notificationReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
